import { Link } from 'gatsby'
import React from 'react'
import { useLink } from '../../hooks/useLink'

const NavLink = ({ target, emphasize, lowLight, exact, inverted }) => {
  const { label, url } = useLink(target)

  return (
    <Link
      to={url}
      activeClassName="u-nav-link--active"
      className={`u-nav-link z-50 transform-gpu whitespace-nowrap transition-all ${
        emphasize && 'font-bold'
      } ${lowLight && 'opacity-30'} ${inverted ? 'u-nav-link--inverted' : ''}`}
      partiallyActive={!exact && !url.endsWith('/swisslift')}
    >
      {label}
    </Link>
  )
}

export default NavLink
